module.exports = __webpack_public_path__ + "static/media/29COICT12.478d4654.jpg";